<section class="section section-2">

  <div class="container">

    <div class="text-center mb-5">

      <span class="section-badge">
        WHO CAN USE CLOCKFLEX
      </span>

      <h2 class="section-title">
        Built for Every Service Business
      </h2>

      <p class="section-subtitle">
        Whether you're managing appointments, teams, clients, or payments,
        ClockFlex adapts to your business.
      </p>

    </div>

    <div class="row g-4">

      <div class="col-lg-3 col-md-4 col-6">
        <div class="industry-card">
          <i class="fas fa-user-md"></i>
          <h5>Healthcare</h5>
          <p>Doctors, Dentists, Clinics</p>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-6">
        <div class="industry-card">
          <i class="fas fa-spa"></i>
          <h5>Beauty & Salon</h5>
          <p>Salons, Makeup Artists</p>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-6">
        <div class="industry-card">
          <i class="fas fa-dumbbell"></i>
          <h5>Fitness</h5>
          <p>Gyms, Trainers, Coaches</p>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-6">
        <div class="industry-card">
          <i class="fas fa-graduation-cap"></i>
          <h5>Education</h5>
          <p>Teachers, Tutors</p>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-6">
        <div class="industry-card">
          <i class="fas fa-gavel"></i>
          <h5>Legal</h5>
          <p>Lawyers, Consultants</p>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-6">
        <div class="industry-card">
          <i class="fas fa-house-user"></i>
          <h5>Real Estate</h5>
          <p>Agents & Brokers</p>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-6">
        <div class="industry-card">
          <i class="fas fa-tools"></i>
          <h5>Home Services</h5>
          <p>Plumbers, Electricians</p>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-6">
        <div class="industry-card">
          <i class="fas fa-camera"></i>
          <h5>Creative</h5>
          <p>Photographers, Creators</p>
        </div>
      </div>

    </div>

  </div>

</section>